<template>
  <v-list-item v-if="siret">
    <v-list-item-content>
      <v-list-item-title>
        <SimpleChips :icon="iconUnite" short="true"
                     v-bind:value="siret.etatAdministratifUniteLegale" :tooltip="tooltipUnite"></SimpleChips>
        <SimpleChips v-if="siret.etablissementSiege==='true' || siret.etablissementSiege===true" :tooltip="tooltipEtab" class="ma-2"
                     icon="mdi-alpha-s-circle-outline" short="true"
                     v-bind:value="siret.etatAdministratifEtablissement"></SimpleChips>

        <SimpleChips v-if="siret.etablissementSiege==='false'" :tooltip="tooltipEtab" class="ma-2"
                     icon="mdi-alpha-e-circle-outline" short="true"
                     v-bind:value="siret.etatAdministratifEtablissement"></SimpleChips>
        <a @click="displayEtablissement">
          {{ nom }}
        </a>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ siret.siret }} | {{ siret.categorieJuridiqueUniteLegaleLibelle }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        {{ siret.activitePrincipaleEtablissement }} | {{
          siret.activitePrincipaleEtablissementLibelle
        }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        {{ this.getAdresse }}
      </v-list-item-subtitle>

    </v-list-item-content>
  </v-list-item>
</template>

<script>

import SimpleChips from '@/components/layout/SimpleChips.vue'

export default {
  name: 'SiretItem',
  props: ['siret'],
  components: {
    SimpleChips
  },
  computed: {
    getAdresse() {
      return [
        this.siret.numeroVoieEtablissement,
        this.siret.indiceRepetitionEtablissement,
        this.siret.typeVoieEtablissement,
        this.siret.libelleVoieEtablissement,
        this.siret.codePostalEtablissement,
        this.siret.libelleCommuneEtablissement
      ].filter(value => value !== undefined && value !== null && value !== '').join(' ')
    },
    iconUnite() {
      if (this.siret.categorieJuridiqueUniteLegale === "1000") {
        return (this.siret.etablissementSiege === "true" ? "mdi-account-star" : "mdi-account")
      } else if (this.siret.etablissementSiege === "true") {
        return "mdi-office-building-marker-outline"
      } else {
        return "mdi-office-building-outline"
      }


    },
    tooltipUnite() {
      var tooltip = "Entreprise"
      if (this.siret.categorieJuridiqueUniteLegale === "1000") {
        tooltip = "Personne physique"
      } else {
        tooltip = "Personne morale"
      }
      if (this.siret.etablissementSiege === "true") {
        tooltip = tooltip + " (Siège)"
      }
      if (this.siret.etatAdministratifUniteLegale === "A") {
        tooltip = tooltip + " Actif"
      } else {
        tooltip = tooltip + " Cessé"
      }
      return tooltip
    },
    tooltipEtab() {
      var tooltip = "Etablissement"
      if (this.siret.etablissementSiege === "true") {
        tooltip = tooltip + " (Siège)"
      }
      if (this.siret.etatAdministratifEtablissement === "A") {
        tooltip = tooltip + " Actif"
      } else {
        tooltip = tooltip + " Fermé"
      }
      return tooltip
    },
    nom() {
      // find fistinct names from all sources of names
      if ( this.siret.statutDiffusionEtablissement=="P") {
        return ("(Identité non diffusé - RGPD)")
      } else {

        const names = [
          this.siret.denominationUniteLegale,
          this.siret.denominationUsuelle1UniteLegale,
          this.siret.denominationUsuelle2UniteLegale,
          this.siret.denominationUsuelle3UniteLegale,
          this.siret.sexeUniteLegale,
          this.siret.nomUniteLegale,
          this.siret.nomUsageUniteLegale,
          this.siret.prenomUsuelUniteLegale,
          this.siret.prenom1UniteLegale,
          this.siret.prenom2UniteLegale,
          this.siret.prenom3UniteLegale,
          this.siret.prenom4UniteLegale,
          this.siret.pseudonymeUniteLegale,
          this.siret.denominationUsuelleEtablissement,
          this.siret.enseigne1Etablissement,
          this.siret.enseigne2Etablissement,
          this.siret.enseigne3Etablissement,
          this.siret.sigleUniteLegale

        ]
        return [...new Set(names)].join(' ')
      }
    }
  },
  methods: {
    displayEtablissement() {
      // this.$store.dispatch('getEtablissement',this.siret.siret)
      //emit event to all aprent. Will be caught by APP to update Etablissement
      //let vm = this.$parent
      //while (vm) {
      //   vm.$emit("displayetablissement", this.siret.siret)
      //  vm = vm.$parent
      //}


    }
  },
};

</script>
